import { LongTextInput, SimpleForm, TextInput } from "react-admin";

import DefaultToolbar from "../components/DefaultToolbar";
import React from "react";

const Form = (props) => (
  <SimpleForm {...props} redirect="list" toolbar={<DefaultToolbar />}>
    <TextInput source="key" fullWidth />
    <TextInput source="value" fullWidth />
    <LongTextInput source="description" />
  </SimpleForm>
);
export default Form;
